import React, {useState} from 'react';
import {
   View,
   ActivityIndicator,
   Image,
   StyleSheet,
   TouchableOpacity,
   Platform,
} from 'react-native';
import logger from '../../utils/logger';
import {ActivityLoaderColor} from '../../utils/utils';

function navigateToWebView(path, navigation) {
   if (Platform.OS === 'macos' || Platform.OS === 'windows') {
      navigation.navigate('WebViewContainerMacos', {
         urlPath: path,
         isShowingByBase64Str: false,
         sharingEnabled: false,
      });
   } else {
      navigation.navigate('WebViewContainer', {
         urlPath: path,
         isShowingByBase64Str: false,
         sharingEnabled: false,
         title: 'Advertisement',
      });
   }
}
const imgAspectRatio = 0.75;
export const AdevertisementItem = ({item, navigation, posterWidth}) => {
   const [loading, setLoading] = useState(true);

   const handleImageLoad = () => {
      setLoading(false);
   };
   return (
      <TouchableOpacity
         onPress={() => {
            logger('image pressed' + item.Link);
            navigateToWebView(item.Link, navigation);
            /*navigation.navigate('WebViewContainer', {
        urlPath: item.Link,
        isShowingByBase64Str: false,
        sharingEnabled:false,
      });*/
         }}>
         <View
            style={[
               styles.itemContainer,
               {
                  ...Platform.select({
                     web: {
                        marginBottom: 8,
                     },
                  }),
               },
            ]}>
            {loading && (
               <ActivityIndicator
                  size="small"
                  color={ActivityLoaderColor}
                  style={{
                     position: 'absolute',
                     top: 0,
                     bottom: 0,
                     left: 0,
                     right: 0,
                     zIndex: 1,
                  }}
               />
            )}

            <Image
               source={{uri: item.Image}}
               style={[
                  styles.posterImage,
                  {width: posterWidth, height: posterWidth * imgAspectRatio},
               ]}
               onLoadEnd={handleImageLoad}
            />
         </View>
      </TouchableOpacity>
   );
};

const styles = StyleSheet.create({
   container: {
      flex: 1,
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: '#F5FCFF',
   },
   contentContainer: {
      paddingVertical: 0,
   },
   itemContainer: {
      flex: 1,
      alignItems: 'center',
      marginBottom: 8,
   },
   posterImage: {
      width: '100%',
      height: 200,
      resizeMode: 'contain',
   },
});
